import React, { useCallback, useState } from "react";
import { Alert } from "react-bootstrap";
import { useCart } from "../../hooks/use-cart";
import CartPurchaser from "./CartPurchaser";
import "./ExportBuilder.scss";
import ExportColumnSelector from "./ExportColumnSelector";
import ExportPreview from "./ExportPreview";
import { FieldAvailable } from "./get-fields-available";

interface ExportBuilderProps {}

const ExportBuilder: React.FC<ExportBuilderProps> = () => {
  const { isCartEmpty, setColumnOrder, cart } = useCart();
  const [fieldsSelected, setFieldsSelected] = useState<FieldAvailable[]>([]);

  const handleFieldsUpdated = useCallback(
    (fields: FieldAvailable[]) => {
      setFieldsSelected(fields);
      setColumnOrder(fields.map((f) => f.key));
    },
    [setColumnOrder],
  );

  if (isCartEmpty) {
    return (
      <div className="export-builder">
        <div className="export-builder-header">Export Builder</div>
        <Alert variant="info">No investors in cart.</Alert>
      </div>
    );
  }

  return (
    <div className="export-builder">
      <CartPurchaser hasFieldsSelected={fieldsSelected.length > 0} />
      <ExportColumnSelector
        columnOrder={cart?.columnOrder ?? []}
        onFieldsUpdated={handleFieldsUpdated}
      />
      <ExportPreview columns={fieldsSelected} rows={cart?.items ?? []} />
    </div>
  );
};

export default ExportBuilder;
